import types from './types';

const INITIAL_STATE = {
    step: 1,
    steps: [],
    exemption: null,
};

export default (state = INITIAL_STATE, action) => {
    // initializing the state by margin default with preloaded state
    if (!state.hydrated) {
        state = { ...INITIAL_STATE, ...state, hydrated: true };
    }

    switch (action.type) {
        case types.REGISTER_STEP: {
            return {
                ...state,
                steps: [...state.steps, action.number],
            };
        }
        case types.CHANGE_STEP: {
            return { ...state, step: action.step };
        }
        case types.CHANGE_EXEMPTION: {
            return { ...state, exemption: action.exemption };
        }
        default:
            return state;
    }
};
